import React from 'react';
import { Button, ButtonGroup, Card } from 'react-bootstrap';

const PresetFilters = ({ onApplyPreset }) => {
  const presets = [
    {
      id: 'highCreditScore',
      name: 'High Credit Score (750+)',
      description: 'Users with excellent credit scores',
      filters: {
        'cibiltusc3_score_value': { min: 750, max: 900 }
      }
    },
    {
      id: 'youngAge',
      name: 'Young Age (25-35)',
      description: 'Young professionals',
      filters: {
        'dm001s': { min: 25, max: 35 }
      }
    },
    {
      id: 'lowRisk',
      name: 'Low Risk Profile',
      description: 'No recent delinquencies',
      filters: {
        'percentage_accounts_ever_delinquent': { min: 0, max: 5 }
      }
    },
    {
      id: 'activeBorrowers',
      name: 'Active Borrowers',
      description: 'Users with multiple active loans',
      filters: {
        'at01s': { min: 2, max: 50 }
      }
    },
    {
      id: 'premiumCustomers',
      name: 'Premium Customers',
      description: 'High score + high balance',
      filters: {
        'cibiltusc3_score_value': { min: 800, max: 900 },
        'at33a': { min: 500000, max: 10000000 }
      }
    }
  ];

  return (
    <Card className="mb-3">
      <Card.Body>
        <h6 className="mb-3">Quick Presets</h6>
        <div className="d-flex flex-wrap gap-2">
          {presets.map(preset => (
            <Button
              key={preset.id}
              variant="outline-primary"
              size="sm"
              onClick={() => onApplyPreset(preset.filters)}
              title={preset.description}
            >
              {preset.name}
            </Button>
          ))}
        </div>
      </Card.Body>
    </Card>
  );
};

export default PresetFilters;